import {alphas, brandColor, greys} from '../../styles/colorStyles';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';
import {lightAccentSemanticStyles} from '../semantic/accentSemanticStyles';
import {lightAnnotationSemanticStyles} from '../semantic/annotationSemanticStyles';
import {lightAppFrameSemanticStyles} from '../semantic/appFrameSemanticStyles';
import {lightBackgroundSemanticStyles} from '../semantic/backgroundSemanticStyles';
import {lightBorderSemanticStyles} from '../semantic/borderSemanticStyles';
import {lightCellSemanticStyles} from '../semantic/cellSemanticStyles';
import {lightCommentComposerSemanticStyles} from '../semantic/commentComposerSemanticStyles';
import {lightComposerSemanticStyles} from '../semantic/composerSemanticStyles';
import {lightIconSemanticStyles} from '../semantic/iconSemanticStyles';
import {lightInlineBannerSemanticStyles} from '../semantic/inlineBannerSemanticStyles';
import {lightInputSemanticStyles} from '../semantic/inputSemanticStyles';
import {lightLeftBarSemanticStyles} from '../semantic/leftBarSemanticStyles';
import {lightMessageSemanticStyles} from '../semantic/messageSemanticStyles';
import {lightMetricsSemanticStyles} from '../semantic/metricsSemanticStyles';
import {lightMobileSemanticStyles} from '../semantic/mobileSemanticStyles';
import {sharedSearchBarSemanticStyles} from '../semantic/searchBarSemanticStyles';
import {lightSettingsSemanticStyles} from '../semantic/settingsSemanticStyles';
import {lightSidePanelSemanticStyles} from '../semantic/sidePanelSemanticStyles';
import {lightTabSemanticStyles} from '../semantic/tabSemanticStyles';
import {lightTagSemanticStyles} from '../semantic/tagSemanticStyles';
import {lightTextSemanticStyles} from '../semantic/textSemanticStyles';
import {lightToggleSemanticStyles} from '../semantic/toggleSemanticStyles';
import {lightTooltipSemanticStyles, upsellTooltipSemanticStyles} from '../semantic/tooltipSemanticStyles';
import {sharedTopBarSemanticStyles} from '../semantic/topBarSemanticStyles';
import {
  lightTypographySemanticStyles,
  mobileLightTypographySemanticStyles,
} from '../semantic/typographySemanticStyles';
import {lightVerticalSwitcherSemanticStyles} from '../semantic/verticalSwitcherSemanticStyles';
import {SemanticStyles} from '../themeTypes';
import {LIGHT_APP_FOREGROUND_COLOR} from './lightColorHelpers';

export const lightSemanticStyles: SemanticStyles = {
  rounded: true,

  brand: brandColor,
  accent: lightAccentSemanticStyles,

  defaultInboxColor: lightAccentSemanticStyles.gray.highlight,
  indicatorColor: lightAccentSemanticStyles.red.highlight,

  appBackground: greys.shade20,
  foreground: LIGHT_APP_FOREGROUND_COLOR,

  invertedIcon: alphas.white50,

  modalBackdrop: alphas.black50,

  colorScheme: 'normal',

  windowsButtonHover: alphas.white20,

  scrollbarTrack: colorPrimitive.alpha.transparent,
  scrollbarThumb: colorPrimitive.alpha.black.black400,

  textStyles: lightTextSemanticStyles,
  typography: lightTypographySemanticStyles,
  mobileTypography: mobileLightTypographySemanticStyles,
  mobile: lightMobileSemanticStyles,
  icon: lightIconSemanticStyles,

  cell: lightCellSemanticStyles,
  topBar: sharedTopBarSemanticStyles,
  sidePanel: lightSidePanelSemanticStyles,
  searchBar: sharedSearchBarSemanticStyles,
  tab: lightTabSemanticStyles,
  tag: lightTagSemanticStyles,
  message: lightMessageSemanticStyles,
  inlineBanner: lightInlineBannerSemanticStyles,
  annotation: lightAnnotationSemanticStyles,
  commentComposer: lightCommentComposerSemanticStyles,
  leftBar: lightLeftBarSemanticStyles,
  settings: lightSettingsSemanticStyles,
  toggle: lightToggleSemanticStyles,
  appFrame: lightAppFrameSemanticStyles,
  tooltip: lightTooltipSemanticStyles,
  upsellTooltip: upsellTooltipSemanticStyles,
  input: lightInputSemanticStyles,
  border: lightBorderSemanticStyles,

  verticalSwitcher: lightVerticalSwitcherSemanticStyles,

  metrics: lightMetricsSemanticStyles,

  background: lightBackgroundSemanticStyles,

  composer: lightComposerSemanticStyles,
};
